import { BrowserRouter, Route, Routes } from "react-router-dom";

// Publicly Availabe Pages:
import HomePage from "./pages/HomePage";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import ProductListPage from "./pages/ProductListPage";
import CartPage from "./pages/CartPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";

// Protected User Pages:
import UserProfilePage from "./pages/user/UserProfilePage";
import UserCartDetailsPage from "./pages/user/UserCartDetailsPage";
import UserOrderDetailsPage from "./pages/user/UserOrderDetailsPage";
import UserOrdersPage from "./pages/user/UserOrdersPage";

import ProtectedRoutesComponent from "./components/ProtectedRoutesComponent";

// Protected Admin Pages:
import AdminUserPage from "./pages/admin/AdminUserPage";
import AdminEditUserPage from "./pages/admin/AdminEditUserPage";
import AdminProductsPage from "./pages/admin/AdminProductsPage";
import AdminCreateProuductPage from "./pages/admin/AdminCreateProuductPage";
import AdminEditProductPage from "./pages/admin/AdminEditProductPage";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage";
import AdminOrderDetailsPage from "./pages/admin/AdminOrderDetailsPage";
import AdminChatsPage from "./pages/admin/AdminChatsPage";
import AdminAnalyticsPage from "./pages/admin/AdminAnalyticsPage";

// Header and Footer Components:
import FooterComponent from "./components/FooterComponent";
import HeaderComponent from "./components/HeaderComponent";

// User Components:
import RoutesWithUserChatComponent from "./components/user/RoutesWithUserChatComponent";
import ScrollToTop from "./utils/ScrollToTop";

export const URL = process.env.REACT_APP_SERVER_URL

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop/>
      <HeaderComponent />
      <Routes>
        <Route element={<RoutesWithUserChatComponent />}>
          {/* Publicly Available Routes */}
          <Route path="/privacy-policy" element={<HomePage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/product-details/:id" element={<ProductDetailsPage />} />
          <Route path="/product-list" element={<ProductListPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="*" element="404 | Page Not Found " />

          {/* User Protected Routes */}
          {/* <Route element={<ProtectedRoutesComponent admin={false} />}> */}
            <Route path="/user" element={<UserProfilePage />} />
            <Route path="/user/cart-details" element={<UserCartDetailsPage />} />
            <Route
              path="/user/order-details/:id"
              element={<UserOrderDetailsPage />}
            />
            <Route path="/user/my-orders" element={<UserOrdersPage />} />
            {/* </Route> */}
          {/* </Route> */}
        </Route>  
        {/* Admin Protected Routes */}
        {/* <Route element={<ProtectedRoutesComponent admin={true} />}> */}
          <Route path="/admin/users" element={<AdminUserPage />} />
          <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
          <Route path="/admin/edit-user" element={<AdminEditUserPage />} />
          <Route path="/admin/products" element={<AdminProductsPage />} />
          <Route
            path="/admin/create-new-product"
            element={<AdminCreateProuductPage />}
      
          />
          <Route
            path="/admin/edit-product/:id"
            element={<AdminEditProductPage />}
          />
          <Route path="/admin/orders" element={<AdminOrdersPage />} />
          <Route
            path="/admin/order-details/:id"
            element={<AdminOrderDetailsPage />}
          />
          <Route path="/admin/chats" element={<AdminChatsPage />} />
        {/* </Route> */}
      </Routes>
      <FooterComponent />
    </BrowserRouter>
  );
}

export default App;
